import {
    CRUD_CHANGE_LIST_PARAMS
} from 'store/actions/listActions';
import {
    CRUD_GET_LIST_SUCCESS
} from 'store/actions/dataActions';
import { LOCATION_CHANGE } from 'connected-react-router';

const initialState = {};
let previousPathname = '';

export default (previousState = initialState, { type, payload, meta }) => {

    switch (type) {
        case LOCATION_CHANGE://다른 메뉴로 이동하는 경우 구조가 달라 에러발생하므로 초기화
            if( previousPathname !== payload.location.pathname ) {
                const previous = previousPathname.split("/");
                const now = payload.location.pathname.split("/");
                previousPathname = payload.location.pathname;
                // TODO: 좀더 정형화할 수 없을지
                if( previous[1] !== now[1] || // topMenu가 변경된 경우 
                    ( previous.length > 2 && now.length > 2 && previous[2] !== now[2] ) || // subMenu가 변경된 경우 
                    ( payload.location.pathname.indexOf("/company/account") === 0 && previous.length > 3 && now.length > 3 && previous[3] !== now[3] ) // 사용자 관리와 별칭계정 관리의 경우 목록 URL이 3단계이므로 추가
                ) {
                    return initialState;
                }
            }
            return previousState;

        case CRUD_CHANGE_LIST_PARAMS:
            return payload;
        
        case CRUD_GET_LIST_SUCCESS:
            // Main메뉴의 목록조회인 경우에만 해당(ex. Header 혹은 Detail에 필요한 목록조회는 제외)
            if( meta.menu.indexOf("DOCUMENT.") > -1) {
                // response의 page정보가 request와 다른 경우 
                let pageNo = typeof previousState.page === 'string' ? Number(previousState.page) : previousState.page;
                if( payload.page && payload.page !== pageNo ) {
                    return { ...previousState, page: payload.page };
                }
            }
            return previousState;

        default:
            return previousState;
    }
    
};